import { z } from 'zod';
import * as t from 'Shared/model/basic';
import {lineup} from 'Shared/model/lineup';


const managerRequest = z.object({
	email: t.email,
	artistName: z.string(),
	time: t.dateTime
});

export const eventParent = z.object({
	_id: t.id(),
	siteId: t.id(),
	slug: z.string(),
	name: z.string(),
	times: t.eventCalendarSettings,
	shortDescription: z.string().max(200),
	buyOrBook: z.object({
		type: z.enum(['url','embed','free']),
		buttonLabel: z.enum(['buyNow','bookNow','custom']).optional(),
		customPrice: z.string().max(32).optional(),
		purchaseLink: t.url.optional(),
		embed: z.any().optional(),
	}),
//	shareImage: t.image,
	facebookImage: t.image,
	instagramImage: t.image,
	announceOnFacebook:z.boolean(),
	announceOnInstagram:z.boolean(),
	status: z.string().max(100),	//XXX can do better
	scheduleDate: t.dateTime, 
	announceDate: t.dateTime,

	//TODO Should be one or the other (or neither)
	managerRequest: managerRequest.optional(),
	artistId: t.id().optional(),

	poster: z.object({
		posterId:  t.id().optional(),
		auto:      z.boolean().optional(),
		design:    z.any().optional(),
		hash:      z.string().optional(),
		formats:   t.imageFormats.optional(),
		dev:       z.boolean().optional(),
		isCurrent: z.boolean().optional(),
	}).optional(),
})
.partial().required({
	_id: true,
	siteId: true,   //FIXME only in server I think
	slug: true,
	status: true
});

//TODO make these events strict. Currently cross-contamination

export const musicEvent = eventParent.extend({
	eventType: z.literal('music'),
	lineup: lineup,
});

export type MusicEvent = z.infer<typeof musicEvent>;

export const socialEvent = eventParent.extend({
	eventType: z.literal('social'),
	nonMusicDescription: z.string().max(200).optional(),
});

export type SocialEvent = z.infer<typeof socialEvent>;

export const tvEvent = eventParent.extend({
	eventType: z.literal('tv'),
	nonMusicDescription: z.string().max(200).optional(),
});

export type TvEvent = z.infer<typeof tvEvent>;

export const eventDoc = z.discriminatedUnion('eventType',[musicEvent,socialEvent,tvEvent]);

export type EventDoc = z.infer<typeof eventDoc>;

export const eventDocs = z.array(eventDoc);
export type EventDocs = z.infer<typeof eventDocs>;

export type EventType = 'music'|'social'|'tv';

export const posterImageFields = ['hash','formats','dev','isCurrent'];

/*
	The best stored render to show, and the size it is filed under. Renders captured before 'large'
	existed have only the medium one, and they are not re-rendered until their event is next edited,
	so the larger size is preferred rather than assumed. Every size is the same picture, so falling
	back costs nothing but resolution - and 'full' is always there, which is what keeps callers from
	having to handle a missing one.
*/
export function posterDisplayImage(formats:t.ImageFormats):{size:t.ImageSize, image:t.ImageDetails}
{
	if (formats.large!=undefined)
		return {size:'large', image:formats.large};
	if (formats.medium!=undefined)
		return {size:'medium', image:formats.medium};
	return {size:'full', image:formats.full};
}


/*
export class EventCollection
{
	schema = event;

//FIXME REQUIRED TO UPDATE CALENDAR!!
//	hooks:XXX,

//	indexes: XXXX

	images = {
		shareImage: imageSize.squareAllSizes,
		builtPoster: imageSize.squareAllSizes,
		photo: imageSize.landscape,
		image: imageSize.portrait07071AllSizes,
		facebookImage: imageSize.facebookBanner,
		instagramImage: imageSize.squareAllSizes
	}
}
//XXX Q:
// 1. Are these just a specs for what exists? 
//      Can I use them to create the images?
//      
*/

